import axios from './axios';

/**
 * @api post /auth/users/me Get current user info
 * @return {Promise}
 */
export const getCurrentUser = () => axios.get('/auth/users/me');

/**
 * @api put /auth/password Change current user's password
 * @param oldPassword
 * @param newPassword
 * @returns {Promise}
 */
export const changePassword = (oldPassword, newPassword) =>
  axios.put('/auth/password', {
    oldPassword,
    newPassword,
  });

/**
 * @api get /pupils/{userId}/settings Get user settings
 * @param {string} userId
 * @returns {Promise}
 */
export const getProfileSettings = userId => axios.get(`/pupils/${userId}/settings`);

/**
 * @api post /pupils/{userId}/settings/location/permission Update user settings
 * @param {string} userId
 * @param {string} permissions
 * @returns {Promise}
 */
export const updateProfilePermissions = (userId, permissions) =>
  axios.post(`/pupils/${userId}/settings/location`, permissions);

export const getSchoolByTenant = tenantId => axios.get(`/schools/tenants/${tenantId}`);
